import ModelProviders from "@/components/AdminPanel/Account/ModelProviders";
import MyConnections from "@/components/AdminPanel/Account/MyConnections";
import MySettings from "@/components/AdminPanel/Account/MySettings";
import { PreferencesPane } from "@/components/AdminPanel/Account/PreferencesPane";
import OrgGroups from "@/components/AdminPanel/Organization/OrgGroups";
import OrgSettings from "@/components/AdminPanel/Organization/OrgSettings";
import OrgUsers from "@/components/AdminPanel/Organization/OrgUsers";
import { BillingPane } from "@/pages/settings/Account/usage/BillingPane";
import { UsageOverviewPane } from "@/pages/settings/Account/usage/UsageOverviewPane";
import { ArchivePane } from "@/pages/trash/ArchivePane";
import type { ReactNode } from "react";

/**
 * The Manage modal's pane column: tab + scope in, content out. Panes own their
 * own data and verbs; the shell owns the frame.
 *
 * Settings splits two ways, as the design system does: the heavy interactive
 * scopes stay page swaps, while every Preferences scope renders the one stacked
 * page that runs the rail as its table of contents (hence `setScope`).
 */
const ACCOUNT_SCOPES = new Set([
  "Profile",
  "Organization",
  "Members",
  "Groups",
]);

export function renderManagePane(
  tabId: string,
  scope: string,
  setScope: (scope: string) => void,
): ReactNode {
  switch (tabId) {
    case "connectors":
      return scope === "Model providers" ? (
        <ModelProviders />
      ) : (
        <MyConnections scope={scope} />
      );

    case "settings":
      if (!ACCOUNT_SCOPES.has(scope)) {
        return <PreferencesPane scope={scope} onScope={setScope} />;
      }
      switch (scope) {
        case "Profile":
          return <MySettings />;
        case "Organization":
          return <OrgSettings />;
        case "Members":
          return <OrgUsers />;
        case "Groups":
          return <OrgGroups />;
        default:
          return null;
      }

    case "usage":
      return scope === "Billing" ? <BillingPane /> : <UsageOverviewPane />;

    case "archive":
      return <ArchivePane scope={scope} />;

    default:
      return null;
  }
}
